import { FindReplace, SearchOutlined } from '@mui/icons-material';
import { Divider, IconButton, ListItemText, Menu, MenuItem } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import SearchDialog from './SearchDialog';
import { useSelector } from 'react-redux';
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import LightTooltip  from '../../commonComponents/LightTooltip';
import { t } from 'i18next';

function SearchButton({setExpandActions}) {
    const parentScreen = useContext(ParentScreenCtx);
    const selectedNode = useSelector(
        (state) =>
            state.treeData[parentScreen].leftTree.tree.body
                .selectedNode
    );

    // States
    const [searchDialog, setSearchDialog] = useState(false);
    const [enableSearch, setEnableSearch] = useState(true);
    const [replaceDialog, setReplaceDialog] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);

    const onClose = () => {
        setSearchDialog(false);
        setReplaceDialog(false);
    }

    useEffect(() => {
        if (selectedNode?.type === 'inboundTemplate' || selectedNode?.type === 'outboundTemplate' || selectedNode?.type === 'workflow') setEnableSearch(false);
        else setEnableSearch(true)
    }, [selectedNode?.key])

    return (
      <>
        <LightTooltip title={t("SRCH")}>
          <span>
            <IconButton
              variant="outlined"
              className="margin-right-4"
              disabled={enableSearch}
              onClick={(event) => {
                if(parentScreen === 'workflow') {
                  setAnchorEl(event.currentTarget);
                } else {
                  setSearchDialog(true);
                }
              }}
              sx={{
                height: "32px !important",
                minHeight: "32px !important",
                width: "32px !important",
                minWidth: "32px !important",
                borderRadius: "0 !important",
              }}>
              <SearchOutlined fontSize="medium"/>
            </IconButton>
          </span>
        </LightTooltip>

        {
          parentScreen === 'workflow' && (
            <Menu
              id="search-menu"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              open={Boolean(anchorEl)}
              onClose={() => setAnchorEl(null)}
              slotProps={{
                list: {
                  sx: {
                    padding: "0px 0 !important",
                  },
                },
              }}
            >
              <MenuItem onClick={() => {
                setSearchDialog(true)
                setAnchorEl(null)
              }}
              sx={{
                display: "flex",
                alignItems: "left",
                gap: "8px",
              }}>
                <SearchOutlined fontSize="small"/>
                <ListItemText primary={t("DIAG_SEARCH_FIND")} />
              </MenuItem>
              <Divider sx={{ margin: "0px !important" }} />
              <MenuItem onClick={() => {
                setSearchDialog(true)
                setReplaceDialog(true)
                setAnchorEl(null)
              }}
              sx={{
                display: "flex",
                alignItems: "left",
                gap: "8px",
              }}>
                <FindReplace fontSize="small"/>
                <ListItemText primary={t("DIAG_REPLACE")} />
              </MenuItem>
            </Menu>
          )
        }

        {searchDialog && <SearchDialog
          open={searchDialog}
          close={onClose}
          setExpandActions={setExpandActions}
          replace={replaceDialog}
        />}
      </>
    );
}

export default SearchButton